import { ref, computed } from 'vue'

export default {
    
    name: "VideoComponent",
    setup(){

    }
}